import React from "react";
import { Layout as AntLayout } from "antd";
import { LayoutProps as AntLayoutProps } from "antd/lib/layout";

export const Content = (props: AntLayoutProps) => {
  const { children, ...rest } = props;
  return <AntLayout.Content {...rest}>{children}</AntLayout.Content>;
};
